var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentionOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 11.9704C2.5 18.0734 6.65473 21.7 12.4174 21.7C13.8844 21.7 15.1872 21.5122 16.0557 21.2188C16.7599 20.9841 17.0063 20.6672 17.0063 20.2564C17.0063 19.8456 16.7364 19.5874 16.2552 19.5874C16.1378 19.5874 15.9853 19.5992 15.7975 19.6344C14.7412 19.8926 13.9314 20.0569 12.7812 20.0569C7.73449 20.0569 4.3309 17.1228 4.3309 12.0408C4.3309 7.12323 7.48802 3.73138 12.2883 3.73138C16.4782 3.73138 19.8701 6.30167 19.8701 11.0315C19.8701 13.4962 18.9781 15.2214 17.6753 15.2214C16.8303 15.2214 16.3726 14.7637 16.3726 13.9656V8.14431C16.3726 7.48706 15.997 7.08802 15.3632 7.08802C14.7412 7.08802 14.3539 7.48706 14.3539 8.14431V8.73114H14.2365C13.7553 7.68658 12.6638 7.08802 11.3728 7.08802C9.03725 7.08802 7.3824 9.05976 7.3824 11.9587C7.3824 14.9045 9.03725 16.9232 11.455 16.9232C12.8164 16.9232 13.8727 16.2425 14.3891 15.0454H14.5065C14.7177 16.2308 15.821 16.9232 17.2763 16.9232C20.0109 16.9232 21.701 14.3999 21.701 10.8907C21.701 5.5388 17.7692 2.1 12.3117 2.1C6.51389 2.1 2.5 5.98479 2.5 11.9704ZM11.8657 15.0923C10.4104 15.0923 9.55365 13.9187 9.55365 11.9704C9.55365 10.0339 10.4222 8.88371 11.8657 8.88371C13.3446 8.88371 14.2835 10.0808 14.2835 11.9587C14.2835 13.8835 13.3328 15.0923 11.8657 15.0923Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentionOutline);
export default __webpack_public_path__ + "static/media/mention_outline.b6e7dbe2b090c1f4307f9f30058c4786.svg";
export { ForwardRef as ReactComponent };